import React, { createContext, useState, useContext } from "react";
import Companies from "../pages/Companies/Companies";

const ComponentContext = createContext();
   
const ComponentContextProvider = ({children}) => {

    const [selectedComponent, setSelectedComponent] = useState(<Companies/>);

    return (
        <ComponentContext.Provider value={{selectedComponent, setSelectedComponent}} >
            {children}
        </ComponentContext.Provider>
    );
}

const useComponentContext = () => {
    const context = useContext(ComponentContext);
    if (context === undefined) {
        throw new Error("useComponentContext must be used within a ComponentContextProvider");
    }

    return context;
}

export { ComponentContextProvider, useComponentContext };
